import Strings from "./strings";
import Types from "./types";

export default class Colors {
  static WHITE = "#ffffff";
  static BLACK = "#000000";
  static DARK = "#1a1a1a";
  static PINK = "#ff005a";
  static YELLOW = "#ffc400";
  static AQUA = "#00babe";
  static PURPLE = "#233177";
  static GRAY = "#9c9c9c";
  static LIGHT_GRAY = "#dbdbdb";
  static CLEAR_GRAY = "#f4f4f4";
  static RED = "#e55502";
  static CLEAR_PURPLE = "#956391";
  static STRONG_PURPLE = "#4c021d";
  static ORANGE = "#ED7808";
  static TEXT_ORANGE = "#ED7808";
  static CLEAR_ORANGE = "#ffba00";
  static SAND = "#e3cba4";
  static GREEN = "#76802a";
  static LIME = "#d0dc64";
}

export const selectColor = (id, screenSize) => {
  switch (id) {
    case Strings.MAIN_COMPONENT_IDS.ABOUT_US:
    case Strings.MAIN_COMPONENT_IDS.WHY_US:
    case Strings.MAIN_COMPONENT_IDS.WHY_US_3:
    case Strings.MAIN_COMPONENT_IDS.WHY_US_5:
    case Strings.MAIN_COMPONENT_IDS.VIDEO:
      return Types.LOGO_WHITE;
    case Strings.MAIN_COMPONENT_IDS.MAIN_MENU:
      if (screenSize !== Types.DESKTOP_SIZE) {
        return Types.LOGO_WHITE;
      } else {
        return Types.LOGO_MAIN;
      }

    default:
      return Types.LOGO_MAIN;
  }
};

export const getRandomColor = () => {
  const colors = [Colors.AQUA, Colors.PURPLE, Colors.YELLOW, Colors.PINK];
  return colors[Math.floor(Math.random() * 4)];
};
